import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Avatar, Card, Typography, Link } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

import gradients from 'utils/gradients';

import { DownloadFile } from 'actions';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	card: {
		cursor: 'pointer',
		marginLeft: theme.spacing(2),
		flexGrow: 1,
		display: 'flex',
		padding: theme.spacing(2),
		alignItems: 'center',
	},
	date: {
		marginLeft: 'auto',
		flexShrink: 0,
	},
	avatarBlue: {
		backgroundImage: gradients.blue,
	},
	avatarGreen: {
		backgroundImage: gradients.green,
		cursor: 'pointer'
	},
	avatarOrange: {
		backgroundImage: gradients.orange,
	},
	avatarRed: {
		backgroundImage: gradients.red,
		cursor: 'pointer'
	},
}));

const DownloadListItem = (props) => {
	const { file, className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();

	const avatars = {
		finished: (
			<Avatar
				className={classes.avatarGreen}
				onClick={file.status === 'Finished' || file.status === 'Finished!' || file.status === 'Finish' ? () => _downloadFile(file.subPath) : null}
			>
				<DownloadIcon />
			</Avatar>
		),
		error: (
			<Avatar
				className={classes.avatarRed}
			>
				<DownloadIcon />
			</Avatar>
		),
		running: (
			<img
				src="./images/gifs/loading.gif"
				alt="loading"
				style={{ width: 33, height: 33, verticalAlign: 'middle', marginRight: 8 }}
			/>
		),
	};

	const rightAvatar = () => {

		if (file.status === 'Finished' || file.status === 'Finished!' || file.status === 'Finish') {
			return avatars['finished'];
		} else if (file.status === 'Error') {
			return avatars['error'];
		} else {
			return avatars['running'];
		}
	};

	const _downloadFile = (subPath) => {
		dispatch(DownloadFile(subPath));
	};

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			{/* {avatars[file.status === 'Finished' || file.status === 'Finished!' || file.status === 'Finish' ? 'finished' : 'running']} */}
			{rightAvatar()}
			<Card
				className={classes.card}
			>
				<Typography variant="body1">
					<Typography
						color="textPrimary"
						to="#"
						variant="h6"
						underline="hover"
						onClick={file.status === 'Finished' || file.status === 'Finished!' || file.status === 'Finish' ? () => _downloadFile(file.subPath) : null}
					>
						{file.filename}
					</Typography>
					{' '}
					{file.key}
					<Typography>
						{file.status}
					</Typography>
				</Typography>
				<Typography className={classes.date} variant="body2">
					{file.user}
					&nbsp;-&nbsp;
					{moment(file.addedDate).format('DD-MM-YYYY HH:mm:SS').toString()}
				</Typography>
			</Card>
		</div>
	);
};

DownloadListItem.propTypes = {
	file: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default DownloadListItem;
